import * as React from 'react';
import SlickSlider, { Settings as SliderSettings } from 'react-slick';
import { StyledSliderContainer, SvgArrow } from './styles';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export interface SliderProps {
	shouldReRender: boolean;
	sliderKey: string;
	sliderSettings: SliderSettings;
}

function SliderPreviousArrow(props: React.SVGProps<SVGSVGElement>) {
	return SliderArrow(props, 'previous');
}

function SliderNextArrow(props: React.SVGProps<SVGSVGElement>) {
	return SliderArrow(props, 'next');
}

function SliderArrow(props: React.SVGProps<SVGSVGElement>, direction: string) {
	const {className, style, onClick} = props;
	const theaterArrowClassName = direction === 'previous'
		? 'TheaterSliderPreviousArrow'
		: 'TheaterSliderNextArrow';
	const mergedClassName = className
		? `${theaterArrowClassName} ${className}`
		: theaterArrowClassName;
	return (
		<SvgArrow
			className={mergedClassName}
			style={{...style}}
			onClick={onClick}
		>
			<use xlinkHref={`#svgicon-iconset_slider-${direction}`} />
		</SvgArrow>
	);
}

class Slider extends React.Component<SliderProps, {}> {

	shouldComponentUpdate(nextProps: SliderProps, nextState: {} ): boolean {
		return nextProps.shouldReRender
			|| nextProps.sliderKey !== this.props.sliderKey
			|| nextProps.sliderSettings.swipe !== this.props.sliderSettings.swipe
			|| nextProps.sliderSettings.draggable !== this.props.sliderSettings.draggable
			|| nextProps.sliderSettings.touchMove !== this.props.sliderSettings.touchMove;
	}

	render() {
		const { children } = this.props;
		const prevArrow = <SliderPreviousArrow/>;
		const nextArrow = <SliderNextArrow/>;
		const sliderSettings = Object.assign({}, this.props.sliderSettings, { prevArrow, nextArrow });

		return (
			<StyledSliderContainer className="StyledSliderContainer">
				<SlickSlider
					key={this.props.sliderKey} // Key needed for react to rerender
					{...sliderSettings}
				>
					{children}
				</SlickSlider>
			</StyledSliderContainer>
		);
	}
}

export default Slider;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Slider/index.tsx